import httpClient from './client/http';
import { createLocationFromJson } from './mappers';

export async function listAll() {
  const response = await httpClient.get(`${import.meta.env.VITE_REST_API_URL}/v1/screen/locations`);

  return {
    data: response.locations.map(createLocationFromJson),
  };
}

export default {
  listAll,
};
